import { createSelector } from 'reselect';
import {
  filter,
  find,
  sortBy,
} from 'lodash';

const getRegSummaries = state => state.seatingChart.regSummaries;
const getRoom = state => state.roomOptions.room;
const getStudentsList = state => state.seatingChart.studentsList;
const getEventRegs = state => state.irregularities.tcEventRegs;
const getRooms = state => state.tcEvent.rooms;

import { addLeadingZeros } from 'shared/helpers';

export const mapRegSummaries = createSelector(
  [getRegSummaries, getRoom],
  (regs, room) => {
    let result = [];
    regs && room && regs.map(reg => {
      if (!result[reg.seatRow]) {
        result[reg.seatRow] = [];
      }
      reg.roomId = room.id;
      if (reg.regMaterials) {
        reg.regMaterials.map(material => {
          material.serialNumber = addLeadingZeros(material.serialNumber);
        })
      }
      
      result[reg.seatRow][reg.seatCol] = reg;
    });

    return result;
  }
);

export const getAllStudents = createSelector(
  [getStudentsList],
  (students) => {
    return sortBy(students, ['lastName', 'firstName']);
  }
);

export const getNotInRoomEventRegs = createSelector(
  [getStudentsList, getEventRegs, getRooms],
  (students, eventRegs, rooms) => {
    return sortBy(filter(eventRegs, reg => {
      return !find(students, {id: reg.id});
    }), ['lastName', 'firstName']).map(reg => {
      let room= find(rooms, {id: reg.roomId})
      reg.fullName = `${reg.lastName.toLowerCase()} ${reg.firstName.toLowerCase()}`;
      reg.roomName = room ? room.name : '';
      return reg;
    });
  }
);
